import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const selectors = {
  slider: "[data-cases-slider]",
};

const init = () => {
  Swiper.use([Navigation, Pagination]);

  const sliders = document.querySelectorAll(selectors.slider);

  if (!sliders) return;

  sliders.forEach((slider) => {
    const type = slider.getAttribute("data-cases-slider");

    new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: type === "large" ? 40 : 8,
      loop: false,
      centeredSlides: type === "large",

      breakpoints: {
        1024: {
          slidesPerView: type === "large" ? "auto" : 3,
        },
      },

      pagination: {
        el: "[data-cases-slider] [data-swiper-pagination]",
        clickable: true,
        bulletActiveClass: "active",
        bulletClass: "bullet",
      },

      navigation: {
        nextEl: "[data-cases-slider] [data-swiper-navigation-next]",
        prevEl: "[data-cases-slider] [data-swiper-navigation-prev]",
      },
    });
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
